import { Avatar, CardBody } from "@doar/components";
import { mean } from "lodash-es";
import { FC, useState } from "react";
import DollarSign from "src/components/svg/DollarSign";
import StethoscopeIcon from "src/components/svg/StethoscopeIcon";
import CONFIG from "src/config";
import { Estimate as EstimateType } from "src/types/api/ticket";
import HospitalIcon from "../../../../../svg/HospitalIcon";
import {
    StyledCard,
    StyledContentItem,
    StyledContentText,
    StyledContentTitle,
    StyledMoneyText,
    StyledProcedureContentItem,
    StyledProcedureItem,
    StyledProceduresCol,
    StyledSeenAllText,
    StyledViewEstimate,
} from "./style";

type Props = {
    estimate: EstimateType;
};

const Estimate: FC<Props> = ({ estimate }) => {
    const [showAll, setShowAll] = useState(false);
    return (
        <StyledCard>
            <CardBody>
                <StyledContentItem>
                    <StyledContentTitle>
                        <DollarSign /> <span>Total Estimate:</span>
                    </StyledContentTitle>

                    <StyledMoneyText>
                        ${mean([estimate.max_total, estimate.min_total])}
                    </StyledMoneyText>
                </StyledContentItem>
                <StyledContentItem>
                    <StyledContentTitle>
                        <StethoscopeIcon /> <span>Provider:</span>
                    </StyledContentTitle>

                    <StyledContentText>
                        <Avatar size="xs" status="online">
                            <img
                                src={`https://ui-avatars.com/api/?name=${String(
                                    estimate.staff?.first_name
                                )}+${String(estimate.staff?.first_name)}`}
                                alt="Avatar"
                            />
                        </Avatar>
                        <span>
                            {[
                                estimate.staff?.first_name,
                                estimate.staff?.last_name,
                            ].join(" ")}
                        </span>
                    </StyledContentText>
                </StyledContentItem>
                <>
                    {estimate?.procedures && estimate?.procedures.length > 0 && (
                        <StyledProcedureContentItem>
                            <div>
                                <StyledContentTitle>
                                    <HospitalIcon />
                                    <span>Procedures:</span>
                                </StyledContentTitle>
                                <StyledViewEstimate
                                    onClick={() => {
                                        window.open(
                                            `${CONFIG.WIDGET_URL}?quote_id=${estimate.text_id}`
                                        );
                                    }}
                                >
                                    View estimate
                                </StyledViewEstimate>
                            </div>
                            {estimate?.procedures &&
                                estimate?.procedures.length > 0 && (
                                    <StyledProceduresCol>
                                        <>
                                            {estimate?.procedures
                                                ?.filter(
                                                    (_, index) =>
                                                        showAll || index < 2
                                                )
                                                .map((procedure) => (
                                                    <StyledProcedureItem
                                                        key={procedure.id}
                                                    >
                                                        {procedure.name}
                                                    </StyledProcedureItem>
                                                ))}

                                            {estimate?.procedures.length >
                                                2 && (
                                                <StyledSeenAllText
                                                    onClick={() =>
                                                        setShowAll(!showAll)
                                                    }
                                                >
                                                    {showAll
                                                        ? "Hide"
                                                        : "See all"}{" "}
                                                    (
                                                    {estimate.procedures.length}
                                                    )
                                                </StyledSeenAllText>
                                            )}
                                        </>
                                    </StyledProceduresCol>
                                )}
                        </StyledProcedureContentItem>
                    )}
                </>
            </CardBody>
        </StyledCard>
    );
};

export default Estimate;
